import { useEffect } from "react";
import { setTracks, toggle, useMusicSelector } from "./music-engine";
import { useReducedMotion } from "../three/scene-utils";
function MusicToggle({
  tracks,
  className = ""
}) {
  const reduced = useReducedMotion();
  const playing = useMusicSelector((s) => s.playing);
  const blocked = useMusicSelector((s) => s.blocked);
  const muted = useMusicSelector((s) => s.muted);
  useEffect(() => {
    setTracks(tracks);
  }, [tracks]);
  if (!tracks.length) return null;
  const silent = !playing || muted;
  return <div className={`no-print fixed bottom-[calc(1rem+env(safe-area-inset-bottom,0px))] right-4 z-50 sm:bottom-6 sm:right-6 ${className}`}>
      <button
    type="button"
    onClick={() => void toggle()}
    aria-label={playing ? "Turn the music off" : "Turn the music on"}
    aria-pressed={playing}
    title={playing ? "Music on" : "Music off"}
    className="music-toggle grid h-12 w-12 place-items-center rounded-full"
  >
        {silent ? (
    /* speaker with a small off-stroke: reads as "sound available, off" */
    <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true" fill="none">
            <path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor" />
            <path d="M17 9.5l4 5M21 9.5l-4 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
  ) : (
    /* three bars of equaliser, moving only when motion is welcome */
    <span className="flex items-end gap-[3px]" aria-hidden="true">
            {[0, 1, 2].map((i) => <span
      key={i}
      className="block w-[2px] rounded-full bg-current"
      style={{
        height: reduced ? 12 : 6,
        animation: reduced ? void 0 : `eq-bar 1.1s ease-in-out ${i * 0.16}s infinite`
      }}
    />)}
          </span>
  )}
      </button>

      {
    /* Autoplay was refused. One quiet line, then it is never shown again. */
  }
      {blocked && !playing && <span className="music-toggle-hint" aria-live="polite">
          tap for sound
        </span>}
    </div>;
}
export {
  MusicToggle
};
